var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.393 6.2a6.14 6.14 0 0 1-1.319 3.78L16 14.91 14.905 16l-4.928-4.93a6.1 6.1 0 0 1-3.781 1.32 6.2 6.2 0 1 1 6.197-6.19m-10.844 0a4.648 4.648 0 1 0 4.648-4.65A4.646 4.646 0 0 0 1.549 6.2"
  })));
};
export default SvgSearch;